export enum FINAL_USERS_LIST_TABLE_COLUMNS {
    NAME = 'name',
    CREATED_AT = 'created_at',
    UPDATED_AT = 'updated_at',
    ACTIONS = 'actions'
}
export const FINAL_USERS_TABLE_HEADER = [
    FINAL_USERS_LIST_TABLE_COLUMNS.NAME,
    FINAL_USERS_LIST_TABLE_COLUMNS.CREATED_AT,
    FINAL_USERS_LIST_TABLE_COLUMNS.UPDATED_AT,
    FINAL_USERS_LIST_TABLE_COLUMNS.ACTIONS
];

export const FINAL_USERS_LIST_DEFAULT_SORT_COLUMN = FINAL_USERS_LIST_TABLE_COLUMNS.CREATED_AT;
export const FINAL_USERS_LIST_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const FINAL_USERS_LIST_PAGE_SIZE_OPTIONS = [5, 10];
export const FINAL_USERS_LIST_PAGE_DEFAULT_SIZE = 5;
